// extracted by mini-css-extract-plugin
export default {"roundLabel":"roundlabel_roundLabel__6qMTR","roundLabelBorder":"roundlabel_roundLabelBorder__nC7j6"};